function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $ = jQuery;
var Pin = /*#__PURE__*/function () {
  function Pin(model, tooltipSettings) {
    var generalSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Pin);
    this.model = model;
    this.map = null;
    this.mouseover = false;
    this.visibilityConditions = {
      tag: true,
      search: true,
      base: !generalSettings.hideInitially
    };

    // Add a utility image object if the pin has an image
    var pinImage = null;
    if (this.model.image.url) {
      pinImage = new Image();
      pinImage.src = this.model.image.url;
    }
    this.image = pinImage;

    // Add a tooltip to the pin
    var tooltip = null;
    if (this.model.tooltipEnabled) {
      tooltip = new MapifyTooltip({
        classes: 'mpfy-tooltip ' + tooltipSettings.classes,
        rgba: tooltipSettings.background,
        content: tooltipSettings.content,
        close_behavior: tooltipSettings.closeBehavior,
        animate: tooltipSettings.animate,
        pinId: tooltipSettings.pinId
      });
    }
    this.tooltip = tooltip;
  }
  return _createClass(Pin, [{
    key: "isVisible",
    value: function isVisible() {
      for (var option in this.visibilityConditions) {
        var condition = this.visibilityConditions[option];
        if (!condition) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(condition, visible) {
      this.visibilityConditions[condition] = visible;
    }
  }]);
}();
;
module.exports = Pin;